import styled from '@emotion/styled';
import { globalPadding } from '../../../Layout/Layout';

type WidgetWrapperProps = { cancelPadding?: boolean; afterTeaser?: boolean; afterSlider?: boolean };

export const WidgetWrapper = styled.div<WidgetWrapperProps>(({ theme, cancelPadding, afterTeaser, afterSlider }) => ({
  ...(cancelPadding ? theme.mixins.create(globalPadding, (p) => ({ margin: `0 -${theme.spacing(p)}` })) : undefined),
  marginTop: '4rem',
  // The slider's bottom margin alone sets the gap to the row under it (see MainSliderWidget).
  ...(afterSlider ? { marginTop: 0 } : undefined),
  position: 'relative',
  '&:first-of-type': { marginTop: 0 },
  // The teaser sits in a raised stacking context (zIndex: 1, see TeaserVideo) so its controls stay
  // clickable. The live widget right after it pulls itself up onto the teaser (LiveCardList's
  // afterTeaser), so the wrapper must out-stack the teaser or the overlap gets clipped underneath.
  // Harmless for non-live widgets, which no longer overlap the teaser.
  ...(afterTeaser ? { zIndex: 2 } : undefined),
}));
